import {
  floor,
  floorArea,
  roomsCount,
} from '../../../components/CustomFilter/constants';
import FloorAreaBody from '../../../components/CustomFilter/FloorAreaBody/FloorAreaBody';
import FloorBody from '../../../components/CustomFilter/FloorBody/FloorBody';
import RoomCountBody from '../../../components/CustomFilter/RoomCountBody/RoomCountBody';
import CheckboxList from '../../../components/CustomFilter/checkboxList';
import { TFilterType } from '../copia.type';
import {
  getChildQueries,
  getCityQueries,
  getFilterChildQueries,
  getFilterCountryQueries,
  getFloorAreaQueries,
  getFloorQueries,
  getPriceQueries,
  getTypeQueries,
} from './getTypeQueries';
import CheckboxPopup from '../../../components/CustomFilter/checkboxPopup';
import ChooseList from '../../../components/CustomFilter/chooseList';
import filterStore from '../../../components/CustomFilter/filter.store';
import NestedList from '../../../components/CustomFilter/nestedList';
import PricePopup from '../../../components/CustomFilter/PricePopup';

const popupBody: any = {
  floorArea: FloorAreaBody,
  floor: FloorBody,
  roomsCount: RoomCountBody,
};

const FilterController = {
  transformData(
    input: Record<string, any>,
    querys: any,
  ): Record<string, any[]> {
    const transformed: Record<string, any> = {};

    Object.entries(input).forEach(([category, value]) => {
      if (!!value?.length || !!Object.keys(value)?.length) {
        if (Array.isArray(value)) {
          const selected = querys[category];

          transformed[category] = {
            selected: false,
            getQueries: getTypeQueries,
            Component: CheckboxList,
            childs: value.map((item) => ({
              ...item,
              query: category,
              selected:
                selected && Object.keys(selected)?.length
                  ? selected?.includes(String(item.id))
                  : false,
              handleChange: (childs: any, child: any) => {
                filterStore.selectType({
                  query: child.id,
                  category,
                });
              },
              getSelectOpt() {
                return {
                  query: item.id,
                  category,
                };
              },
              ...this.getMissingElements(category),
            })),
            ...this.getMissingCategoryElements(category, value, querys),
          };
        } else if (typeof value === 'object') {
          transformed[category] = {
            selected: false,
            getQueries: getFilterChildQueries,
            childs: Object.entries(value).map(([key, items]) => {
              const selected = querys[key];
              const res = {
                query: key,
                selected: false,
                Component: CheckboxPopup,
                getQueries: getChildQueries,
                handleChange: (data: any) => {
                  filterStore.selectCategoryChildValue(
                    category,
                    data,
                    res.query,
                  );
                },
                onConfirm(data: any) {
                  filterStore.openCategoryChild(category, res);
                  this.handleChange(data);
                },
                onCancel() {
                  filterStore.openCategoryChild(category, res);
                },
                toggleSection: () => {
                  filterStore.openCategoryChild(category, res);
                },
                childs: Array.isArray(items)
                  ? items.map((item: TFilterType | any) => ({
                      ...item,
                      getSelectOpt() {
                        return {
                          query: item.id,
                          key,
                          category,
                        };
                      },
                      selected:
                        selected && Object.keys(selected)?.length
                          ? selected?.includes(String(item.id))
                          : false,
                    }))
                  : [],
                ...this.getMissingElements(key, category, querys),
              };

              return res;
            }),
          };
        }
      }
    });

    return transformed;
  },

  getMissingElements: (key: string, category = '', querys: any = {}) => {
    const res: any = {
      floorArea: {
        selected: false,
        childs: floorArea.map((floorAreaEl: any) => ({
          ...floorAreaEl,
          handleChange: (data: any) => {
            filterStore.selectCategoryChildValue(category, data, 'floorArea');
          },
          onConfirm(data: any) {
            filterStore.openCategoryChild(category, floorAreaEl);
            this.handleChange(data);
          },
          onCancel() {
            filterStore.openCategoryChild(category, floorAreaEl);
          },
          selected: querys.floorAreaFrom
            ? querys.floorAreaFrom == floorAreaEl.query.floorAreaFrom
            : false,
        })),
        isSingle: true,
        Component: popupBody[key],
        getQueries: getFloorAreaQueries,
      },
      floor: {
        selected: false,
        childs: floor.map((room: any) => room),
        Component: popupBody[key],
        getQueries: getFloorQueries,
      },
      roomsCount: {
        selected: false,
        childs: roomsCount.map((room: any) => ({
          ...room,
          selected:
            querys.roomsCount && Object.keys(querys.roomsCount)?.length
              ? querys.roomsCount?.includes(String(room.id))
              : false,
        })),
        Component: popupBody[key],
      },
      balcony: {
        isSingle: true,
      },
      petsAllowed: {
        isSingle: true,
      },
      furniture: {
        isSingle: true,
      },
      newConstruction: {
        isSingle: true,
      },
      elevator: {
        isSingle: true,
      },
      breakfast: {
        isSingle: true,
      },
      parking: {
        isSingle: true,
      },
      price: {
        getQueries: getFloorQueries,
      },
    };
    return res[key] || {};
  },

  getMissingCategoryElements: (
    category: string,
    value: any[] = [],
    querys: any,
  ) => {
    const res: any = {
      parking: {
        Component: ChooseList,
      },
      breakfast: {
        Component: ChooseList,
      },
      price: {
        Component: PricePopup,
        getQueries: getPriceQueries,
        childs: value?.map((child: any, index: number) => ({
          ...child,
          query: `price${child.name}`,
          id: querys[`price${child.name}`] || '',
          handleChange(data: any) {
            filterStore.selectCategoryPriceValue(category, data);
          },
          onConfirm(data: any) {
            filterStore.openCategory(category);
            this.handleChange(data);
          },
          onCancel() {
            filterStore.openCategory(category);
          },
          toggleSection() {
            filterStore.openCategory(category);
          },
        })),
      },
      country: {
        Component: NestedList,
        getQueries: getFilterCountryQueries,
        childs: value.map((item, index) => ({
          ...item,
          query: category,
          name: item.name,
          Component: CheckboxPopup,
          getQueries: getCityQueries,
          handleChange(data: any, index: number) {
            filterStore.selectCategoryNestedChildValue(category, data, index);
          },
          childs: item.city?.map((city: any) => ({
            ...city,
            query: 'city',
            selected:
              querys.city && !!JSON.parse(querys.city)?.length
                ? JSON.parse(querys.city)?.find((cityId: any) => cityId == city.id)
                : false,
          })),
          onConfirm(data: any) {
            filterStore.openCategoryNestedChild(category, index);
            this.handleChange(data, index);
          },
          onCancel() {
            filterStore.openCategoryNestedChild(category, index);
          },
          toggleSection() {
            filterStore.openCategoryNestedChild(category, index);
          },
        })),
      },
    };
    return res[category] || {};
  },
};

export default FilterController;
